import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

// Okta sign-in redirect URI MUST exactly match a value registered in the Okta
// app. We support two scenarios out of the box:
//   - Production: bare origin, e.g.
//       https://initiatives-hub.morningstar.com/
//   - Local dev: http://localhost:3000/leaderboard (already registered in Okta)
//
// You can override either via env vars:
//   VITE_OKTA_REDIRECT_URI            — full sign-in redirect URI
//   VITE_OKTA_POST_LOGOUT_REDIRECT_URI — full post-logout redirect URI
const origin = window.location.origin
const isLocalDev = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin)

// Always use the registered Okta redirect URI for local dev regardless of
// whether the browser opened via `localhost` or `127.0.0.1`, since only
// http://localhost:3000/leaderboard is whitelisted in the Okta app settings.
const localPort = window.location.port || '3000'
const redirectUri =
  import.meta.env.VITE_OKTA_REDIRECT_URI ||
  (isLocalDev ? `http://localhost:${localPort}/leaderboard` : `${origin}/`)

const postLogoutRedirectUri =
  import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI ||
  (isLocalDev ? `http://localhost:${localPort}/` : `${origin}/`)

// Shared storage keeps initiative links opened from a context menu/new tab
// authenticated and preserves the intended post-Okta return path.
const authStorage = window.localStorage

export const authConfig = {
  authority: import.meta.env.VITE_OKTA_AUTHORITY,
  client_id: import.meta.env.VITE_OKTA_CLIENT_ID,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code', // Authorization Code + PKCE (SPA)
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: authStorage }),
  stateStore: new WebStorageStateStore({ store: authStorage }),
}

export const userManager = new UserManager(authConfig)

/**
 * Returns true when the current URL is an Okta authorization-code callback
 * (contains both `code` and `state` query params).
 */
export function isOidcCallback() {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return params.has('code') && params.has('state')
}
